(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 9133:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(8851);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ SongStarterButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5992);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2048);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6432);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var Button = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "widthButton" && prop !== "heightButton" && prop !== "fontSizeButton" && prop !== "gradient" && prop !== "variant" && prop !== "colorButton";
    }
})(function(param) {
    var gradient = param.gradient, widthButton = param.widthButton, heightButton = param.heightButton, fontSizeButton = param.fontSizeButton, colorButton = param.colorButton, variant = param.variant, theme = param.theme;
    return _objectSpread({
        height: heightButton,
        width: widthButton,
        fontSize: fontSizeButton,
        fontFamily: "'Biennale', sans-serif",
        fontWeight: 700,
        borderRadius: "10px",
        padding: 0,
        textTransform: "none",
        color: colorButton || theme.palette.common.white
    }, variant === "outlined" && {
        border: "2px solid ".concat(theme.palette.common.white)
    }, {
        background: "rgb(0,0,0,0)"
    }, variant === "contained" && {
        backgroundImage: gradient || "linear-gradient(90deg, rgba(252,92,102,1) 0%, rgba(247,133,85,1) 100%)"
    }, {
        opacity: 1,
        transition: "opacity 0.3s cubic-bezier(0, 0, 0, 1) 0s",
        ":hover": {
            opacity: 0.85
        }
    });
});
var SongStarterButton = function(_param) {
    var onClick = _param.onClick, children = _param.children, _size = _param.size, size = _size === void 0 ? "medium" : _size, _variant = _param.variant, variant = _variant === void 0 ? "contained" : _variant, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _white = _param.white, white = _white === void 0 ? false : _white, gradientOverwrite = _param.gradient, type = _param.type, props = _objectWithoutProperties(_param, [
        "onClick",
        "children",
        "size",
        "variant",
        "fullWidth",
        "white",
        "gradient",
        "type"
    ]);
    var downSM = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
        return theme.breakpoints.down("sm");
    });
    var widthButton, heightButton, fontSizeButton, gradient, color;
    switch(size){
        case "small":
            widthButton = fullWidth ? "100%" : downSM ? 110 : 120;
            heightButton = downSM ? 32 : 36;
            fontSizeButton = downSM ? 13 : 14;
            break;
        case "medium":
            widthButton = fullWidth ? "100%" : downSM ? 230 : 240;
            heightButton = downSM ? 40 : 46;
            fontSizeButton = downSM ? 15 : 16;
            break;
        case "large":
            widthButton = fullWidth ? "100%" : downSM ? 180 : 200;
            heightButton = downSM ? 44 : 50;
            fontSizeButton = downSM ? 16 : 18;
            break;
    }
    if (white) {
        gradient = "linear-gradient(70deg, rgba(242,242,242,1) 0%, rgba(206,206,206,1) 100%)";
        color = variant === "outlined" ? "#fff" : "rgb(0,0,0)";
    }
    if (props.disabled) {
        gradient = "linear-gradient(70deg, rgba(242,242,242,0.2) 0%, rgba(206,206,206,0.2) 100%)";
        color = "rgb(48,48,48)";
    }
    if (gradientOverwrite) {
        gradient = gradientOverwrite;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, _objectSpread({}, props, {
        onClick: onClick,
        variant: variant,
        color: "secondary",
        disableElevation: true,
        type: type,
        widthButton: widthButton,
        heightButton: heightButton,
        fontSizeButton: fontSizeButton,
        colorButton: color,
        gradient: gradient,
        children: children
    }));
};



/***/ }),

/***/ 2418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ HomePage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5992);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8675);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2197);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2078);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1075);
/* harmony import */ var components_SongStarterHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2847);
/* harmony import */ var components_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2620);
/* harmony import */ var components_SongStarterButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2262);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}








var HeaderContainer = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: "relative",
        height: 600
    }, _defineProperty(_obj, theme.breakpoints.down("md"), {
        height: 560
    }), _defineProperty(_obj, theme.breakpoints.down("sm"), {
        height: "85vh",
        minHeight: 400
    }), _obj;
});
var ContentOverlay = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)("div")(function() {
    return {
        position: "absolute",
        width: "100%",
        zIndex: 1
    };
});
var BackgroundImage = (0,_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)("div")(function() {
    return {
        position: "relative",
        width: "100%"
    };
});
var HomePage = function() {
    var push = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().push;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "SongStarter"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        type: "text/css",
                        children: "html { scroll-behavior: smooth; }"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SongStarterHeader__WEBPACK_IMPORTED_MODULE_4__/* .SongStarterHeader */ .L$, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(HeaderContainer, {
                id: "home",
                maxWidth: false,
                disableGutters: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ContentOverlay, {
                        sx: {
                            padding: "0px 8px",
                            display: "flex",
                            justifyContent: "center",
                            height: "100%",
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                variant: "h1",
                                align: "center",
                                sx: {
                                    whiteSpace: "pre-line",
                                    fontWeight: 700,
                                    marginBottom: "16px"
                                },
                                children: "We Moved SongStarter To 'ProducerKits.com'!"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                variant: "h1",
                                align: "center",
                                sx: {
                                    whiteSpace: "pre-line",
                                    fontWeight: 700,
                                    marginBottom: "16px"
                                },
                                children: "We Are Building Something New Here.."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                variant: "h6",
                                fontWeight: 500,
                                color: "textSecondary",
                                align: "center",
                                href: "https://www.producerkits.com/",
                                sx: {
                                    margin: "16px 0px"
                                },
                                children: "Go to ProducerKits.com to continue using your SongStarter account"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                variant: "h4",
                                align: "center",
                                sx: {
                                    whiteSpace: "pre-line",
                                    marginBottom: "32px",
                                    marginTop: "16px"
                                },
                                children: "Still have some questions or \n downloads you need?"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                container: true,
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SongStarterButton__WEBPACK_IMPORTED_MODULE_6__/* .SongStarterButton */ .a, {
                                        variant: "outlined",
                                        white: true,
                                        onClick: function() {
                                            return push("/contact");
                                        },
                                        children: "Contact Us"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BackgroundImage, {
                        sx: {
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            alt: "background",
                            layout: "fill",
                            objectFit: "cover",
                            src: "/background.png"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Footer__WEBPACK_IMPORTED_MODULE_5__/* .Footer */ .$, {})
        ]
    });
};


/***/ }),

/***/ 8851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var containers_HomePage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2418);

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (containers_HomePage__WEBPACK_IMPORTED_MODULE_0__/* .HomePage */ .U);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [90,409,577,164,774,888,179], function() { return __webpack_exec__(9133); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);